var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiScience(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 8.017,
    y: 359.683,
    style: {
      fill: "#E0DDDF"
    },
    width: 495.967,
    height: 70.547
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C1BCBF"
    },
    points: "8.017,413.127 8.017,430.23 256,430.23 503.983,430.23 503.983,413.127 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9FD25A"
    },
    d: "M503.983,430.23v34.205H314.778c-9.898,22.65-32.484,38.48-58.778,38.48s-48.88-15.83-58.778-38.48 H8.017V430.23H503.983z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 8.017,
    y: 9.086,
    style: {
      fill: "#F9F8F9"
    },
    width: 247.983,
    height: 350.597
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 9.086,
    style: {
      fill: "#F9F8F9"
    },
    width: 247.983,
    height: 350.597
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M503.983,1.069H8.017C3.589,1.069,0,4.657,0,9.086v455.349c0,4.428,3.589,8.017,8.017,8.017h44.467 c4.427,0,8.017-3.588,8.017-8.017c0-4.428-3.589-8.017-8.017-8.017h-36.45v-18.171h479.933v18.171H314.778 c-3.185,0-6.07,1.888-7.345,4.807c-8.939,20.455-29.127,33.673-51.433,33.673c-22.305,0-42.494-13.218-51.433-33.673 c-1.276-2.919-4.16-4.807-7.346-4.807H89.253c-4.427,0-8.017,3.588-8.017,8.017c0,4.428,3.589,8.017,8.017,8.017H192.19 c12.423,23.541,36.92,38.48,63.81,38.48c26.891,0,51.388-14.939,63.81-38.48h184.174c4.428,0,8.017-3.588,8.017-8.017V9.086 C512,4.657,508.412,1.069,503.983,1.069z M16.033,367.699h231.95v54.514H16.033V367.699z M264.017,367.699h231.95v54.514h-231.95 V367.699z M247.983,17.102v262.413c0,4.428,3.589,8.017,8.017,8.017c4.428,0,8.017-3.588,8.017-8.017V17.102h231.95v334.564h-231.95 v-35.084c0-4.428-3.588-8.017-8.017-8.017c-4.427,0-8.017,3.588-8.017,8.017v35.084H16.033V17.102H247.983z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#439EE8"
    },
    d: "M422.747,102.614h-85.512c-4.428,0-8.017-3.588-8.017-8.017c0-4.428,3.588-8.017,8.017-8.017h85.512 c4.428,0,8.017,3.588,8.017,8.017C430.764,99.026,427.176,102.614,422.747,102.614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#439EE8"
    },
    d: "M422.747,171.023h-85.512c-4.428,0-8.017-3.588-8.017-8.017c0-4.428,3.588-8.017,8.017-8.017h85.512 c4.428,0,8.017,3.588,8.017,8.017C430.764,167.435,427.176,171.023,422.747,171.023z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#439EE8"
    },
    d: "M422.747,239.432h-85.512c-4.428,0-8.017-3.588-8.017-8.017s3.588-8.017,8.017-8.017h85.512 c4.428,0,8.017,3.588,8.017,8.017S427.176,239.432,422.747,239.432z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBC96C"
    },
    d: "M227.009,315.113l-22.167-18.978v-40.056l22.665-23.013c3.106-3.154,3.068-8.23-0.087-11.337 c-3.156-3.107-8.232-3.068-11.337,0.087l-20.056,20.365l-33.856-19.544c-2.48-1.432-5.536-1.433-8.016,0l-38.662,22.319 c-2.481,1.431-4.008,4.078-4.008,6.942v44.648c0,2.865,1.529,5.511,4.008,6.942l34.15,19.711v10.83 c0,4.428,3.589,8.017,8.017,8.017c4.427,0,8.017-3.588,8.017-8.017v-10.25l27.953-16.136l22.95,19.649 c1.511,1.294,3.365,1.927,5.211,1.927c2.261,0,4.508-0.951,6.094-2.803C230.765,323.053,230.372,317.993,227.009,315.113z  M188.809,291.915l-30.645,17.69l-30.645-17.69v-35.391l30.645-17.69l30.645,17.69V291.915z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBC96C"
    },
    d: "M141.244,255.765c-4.427,0-8.017,3.588-8.017,8.017v21.378c0,4.428,3.589,8.017,8.017,8.017 s8.017-3.588,8.017-8.017v-21.378C149.26,259.354,145.671,255.765,141.244,255.765z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5CC4E0"
    },
    d: "M140.292,159.655l-38.662-22.318c-2.48-1.432-5.537-1.432-8.017,0l-31.443,18.156l-22.967-19.656 c-3.363-2.879-8.424-2.483-11.304,0.878c-2.879,3.364-2.485,8.425,0.879,11.304l22.176,18.978v40.055l-22.673,23.013 c-3.107,3.153-3.07,8.229,0.084,11.337c1.562,1.538,3.594,2.306,5.626,2.306c2.072,0,4.142-0.798,5.711-2.39l20.065-20.366 l33.847,19.544c1.241,0.716,2.625,1.074,4.008,1.074c1.383,0,2.767-0.358,4.008-1.074l38.662-22.319 c2.481-1.432,4.008-4.078,4.008-6.942v-44.637C144.301,163.734,142.772,161.088,140.292,159.655z M128.267,206.606l-30.644,17.69 l-30.636-17.69v-35.38l30.636-17.69l30.644,17.69V206.606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5CC4E0"
    },
    d: "M114.553,207.365c4.427,0,8.017-3.588,8.017-8.017v-21.378c0-4.428-3.589-8.017-8.017-8.017 c-4.427,0-8.017,3.588-8.017,8.017v21.378C106.537,203.777,110.126,207.365,114.553,207.365z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F78B4F"
    },
    d: "M227.508,144.255l-22.665-23.013V81.185l22.167-18.978c3.363-2.88,3.755-7.941,0.875-11.304 c-2.879-3.363-7.941-3.755-11.304-0.875l-22.95,19.649L165.678,53.54V34.739c0-4.428-3.589-8.017-8.017-8.017 c-4.427,0-8.017,3.588-8.017,8.017V54.12l-34.151,19.714c-2.481,1.431-4.008,4.078-4.008,6.942v44.637 c0,2.864,1.527,5.51,4.007,6.942l38.662,22.329c1.241,0.716,2.625,1.074,4.009,1.074s2.768-0.358,4.009-1.074l33.849-19.549 l20.061,20.37c1.569,1.593,3.64,2.391,5.712,2.391c2.031,0,4.063-0.767,5.625-2.305 C230.575,152.485,230.614,147.409,227.508,144.255z M188.809,120.786l-30.645,17.699l-30.645-17.699V85.405l30.645-17.69 l30.645,17.69V120.786z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F78B4F"
    },
    d: "M141.244,84.143c-4.427,0-8.017,3.588-8.017,8.017v21.378c0,4.428,3.589,8.017,8.017,8.017 s8.017-3.588,8.017-8.017V92.16C149.26,87.732,145.671,84.143,141.244,84.143z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiScience);
export default __webpack_public_path__ + "static/media/ai_science.57b12ac13d08b110ad88990dd1599456.svg";
export { ForwardRef as ReactComponent };